import {z} from 'zod';

import {reportFiltersSchema} from './ReportFiltersSchema';

export const discountByMonthSchema = z.object({
  month: z.string(),
  labourDiscount: z.number(),
  materialDiscount: z.number(),
  dmmDiscount: z.number(),
  totalDiscount: z.number(),
});

export type DiscountByMonth = z.infer<typeof discountByMonthSchema>;

export const discountSummarySchema = discountByMonthSchema.omit({month: true});

export type DiscountSummary = z.infer<typeof discountSummarySchema>;

export const discountByMonthResponseSchema = z.object({
  data: z.array(discountByMonthSchema),
  summary: discountSummarySchema,
  filters: reportFiltersSchema,
});

export type DiscountByMonthResponse = z.infer<typeof discountByMonthResponseSchema>;
